import {
  HttpClient,
  HttpContext,
  HttpEvent,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HTTP_CONTEXT } from '../class/app-constant';

@Injectable({
  providedIn: 'root',
})
export class UtiltiyService {
  constructor(private http: HttpClient) {}
  uploadFiles(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('files', file);
    const request = new HttpRequest('POST', `/uploadFile`, formData, {
      reportProgress: true,
      responseType: 'json',
      context: new HttpContext()
        .set(HTTP_CONTEXT.SKIP_SUCCESS, true)
        .set(HTTP_CONTEXT.SKIP_JSON, true),
    });
    return this.http.request(request);
  }
}
